
export const F1_CSS = `
/* ── F1 PALETTE ── */
.f1-accent   { color: #e8002d; }
.f1-silver   { color: #c0c0c0; }
.f1-gold     { color: #ffd700; }

/* ── F1 HEADER ── */
.f1-hdr { border-bottom-color: #3a0a10; }
.f1-hdr .g-title { color: #e8002d; }
.f1-pill { border-color: #7a1020; }

/* ── F1 MENU CARDS ── */
.mc-f1 { background: linear-gradient(135deg,#1a0508,#2a0810); border: 1px solid #7a1020; }
.mc-f1:hover { box-shadow: 0 12px 38px rgba(232,0,45,0.35); }
.mc-f1 .mc-title { color: #e8002d; }
.mc-f1 .mc-hs    { color: #e8002d; }
.mc-f1s { background: linear-gradient(135deg,#1a1a1a,#222); border: 1px solid #505050; }
.mc-f1s:hover { box-shadow: 0 12px 38px rgba(192,192,192,0.25); }
.mc-f1s .mc-title { color: #c0c0c0; }
.mc-f1s .mc-hs    { color: #c0c0c0; }

/* ── TAB NAV ── */
.tab-nav { display:flex; background:#080f1e; border-bottom:2px solid #1a2a4a; position:sticky; top:0; z-index:100; }
.tab-btn { flex:1; padding:12px 8px 10px; background:transparent; border:none; cursor:pointer;
  font-family:'Inter',sans-serif; font-size:0.72rem; font-weight:600; letter-spacing:0.04em;
  color:#4a6a9e; transition:color 0.15s, border-bottom 0.15s;
  border-bottom:3px solid transparent; margin-bottom:-2px; }
.tab-btn:hover { color:#e8edf8; }
.tab-btn.active-football { color:#f5c518; border-bottom-color:#f5c518; }
.tab-btn.active-f1       { color:#e8002d; border-bottom-color:#e8002d; }
.tab-btn.active-multi    { color:#38bdf8; border-bottom-color:#38bdf8; }
.tab-icon { font-size:1.1rem; display:block; margin-bottom:2px; }

/* ── F1 LIVE ── */
.f1-live-wrap { max-width:700px; margin:0 auto; width:100%; padding:12px; display:flex; flex-direction:column; gap:10px; }
.f1-session-badge { display:inline-flex; align-items:center; gap:6px; padding:4px 12px; border-radius:20px;
  font-size:0.58rem; font-weight:700; letter-spacing:0.15em; text-transform:uppercase; }
.f1-session-badge.live { background:rgba(232,0,45,0.15); border:1px solid #e8002d; color:#e8002d; }
.f1-session-badge.ended { background:rgba(192,192,192,0.1); border:1px solid #505050; color:#c0c0c0; }
.f1-weather { display:flex; gap:12px; flex-wrap:wrap; background:#0a1628; border:1px solid #1e3a6e;
  border-radius:10px; padding:10px 14px; }
.f1-weather-item { display:flex; flex-direction:column; align-items:center; gap:1px; }
.f1-weather-val { font-family:'Bebas Neue',sans-serif; font-size:1.4rem; color:#e8edf8; line-height:1; }
.f1-weather-lbl { font-size:0.48rem; color:#4a6a9e; text-transform:uppercase; letter-spacing:0.12em; }
.f1-leaderboard { background:#0a1628; border:1px solid #1e3a6e; border-radius:12px; overflow:hidden; }
.f1-lb-hdr { padding:8px 14px; background:#0f1e38; display:flex; gap:8px; font-size:0.5rem;
  letter-spacing:0.15em; color:#4a6a9e; text-transform:uppercase; }
.f1-lb-row { display:flex; align-items:center; gap:8px; padding:8px 12px; border-top:1px solid #0f1e38;
  transition:background 0.15s; }
.f1-lb-row:hover { background:#0f1e38; }
.f1-pos { font-family:'Bebas Neue',sans-serif; font-size:1.3rem; width:26px; text-align:center; }
.f1-pos.p1 { color:#ffd700; } .f1-pos.p2 { color:#c0c0c0; } .f1-pos.p3 { color:#cd7f32; }
.f1-pos.other { color:#3a5a8e; }
.f1-team-bar { width:4px; height:32px; border-radius:2px; flex-shrink:0; }
.f1-driver { display:flex; flex-direction:column; flex:1; min-width:0; }
.f1-driver-name { font-size:0.82rem; font-weight:700; color:#e8edf8; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.f1-driver-team { font-size:0.58rem; color:#4a6a9e; }
.f1-gap { font-family:'Bebas Neue',sans-serif; font-size:1rem; color:#8ba3cc; min-width:64px; text-align:right; }
.f1-gap.leader { color:#e8002d; }
.f1-lap { font-size:0.6rem; color:#4a6a9e; min-width:48px; text-align:right; }
.f1-pit-badge { font-size:0.52rem; font-weight:700; padding:2px 6px; border-radius:4px;
  background:rgba(232,0,45,0.2); border:1px solid #e8002d; color:#e8002d; white-space:nowrap; }
.f1-drs-badge { font-size:0.52rem; font-weight:700; padding:2px 6px; border-radius:4px;
  background:rgba(34,197,94,0.2); border:1px solid #22c55e; color:#22c55e; }
.f1-rc { display:flex; flex-direction:column; gap:5px; }
.f1-rc-msg { display:flex; gap:8px; align-items:flex-start; padding:7px 10px; border-radius:8px;
  background:#0f1e38; border-left:3px solid #3a5a8e; font-size:0.72rem; color:#e8edf8; }
.f1-rc-msg.sc   { border-left-color:#f5c518; background:#1a1808; }
.f1-rc-msg.vsc  { border-left-color:#f5c518; background:#1a1808; }
.f1-rc-msg.flag { border-left-color:#e8002d; background:#1a0508; }
.f1-rc-msg.penalty { border-left-color:#c084fc; background:#120820; }
.f1-rc-time { font-size:0.58rem; color:#4a6a9e; white-space:nowrap; margin-top:1px; }

/* ── F1 PREDICTOR ── */
.f1-pred-card { background:#0f1e38; border:1px solid #3a0a10; border-radius:12px; padding:16px; }
.f1-pred-driver-grid { display:grid; grid-template-columns:1fr 1fr; gap:7px; }
.f1-pred-driver-btn { padding:9px 10px; border-radius:9px; border:2px solid #1e3a6e; background:#0a1628;
  color:#8ba3cc; cursor:pointer; font-size:0.74rem; font-weight:600; text-align:left;
  transition:border-color 0.14s,color 0.14s,background 0.14s; display:flex; align-items:center; gap:7px; }
.f1-pred-driver-btn:hover { border-color:#e8002d; color:#e8002d; background:#1a0508; }
.f1-pred-driver-btn.selected { border-color:#e8002d; color:#e8002d; background:#1a0508; }
.f1-driver-num { font-family:'Bebas Neue',sans-serif; font-size:1.1rem; opacity:0.6; }

/* ── F1 STANDINGS ── */
.f1-standings-tabs { display:flex; gap:8px; }
.f1-standings-tab { padding:7px 16px; border-radius:8px; border:1px solid #1e3a6e; background:transparent;
  color:#4a6a9e; cursor:pointer; font-size:0.74rem; font-family:'Inter',sans-serif; transition:0.15s; }
.f1-standings-tab.active { border-color:#e8002d; color:#e8002d; background:rgba(232,0,45,0.08); }
.f1-constructor-bar { height:6px; border-radius:3px; margin-top:4px; }

/* ── F1 SESSION PICKER ── */
.f1-session-grid { display:grid; grid-template-columns:1fr 1fr; gap:8px; }
.f1-session-btn { padding:12px 10px; border-radius:10px; border:2px solid #1e3a6e; background:#0f1e38;
  color:#8ba3cc; cursor:pointer; font-size:0.78rem; font-weight:600; text-align:center;
  transition:0.14s; display:flex; flex-direction:column; gap:3px; }
.f1-session-btn:hover { border-color:#e8002d; color:#e8002d; background:#1a0508; }
.f1-session-btn.active { border-color:#e8002d; color:#e8002d; background:#1a0508; }
.f1-session-type { font-family:'Bebas Neue',sans-serif; font-size:1.1rem; letter-spacing:0.06em; }
.f1-session-date { font-size:0.6rem; color:#4a6a9e; }

@media(max-width:640px){
  .f1-pred-driver-grid { grid-template-columns:1fr 1fr; }
  .f1-session-grid { grid-template-columns:1fr; }
}
`;
